<template lang="html">
	<div class="range-slider" :class="{ disabled }">
		<div class="range-slider-label">
			<div class="range-slider-label-text"></div>
			<div class="range-slider-value">{{ _valueFormat }}</div>
		</div>

		<drag-helper v-bind:disabled="disabled" @dragstart="dragStart" @drag="drag" @dragend="dragEnd">
			<span ref="inner" class="range-slider-inner">
				<input class="range-slider-hidden" type="text" :name="name" :value="actualValue" :disabled="disabled" />
				<span class="range-slider-rail"></span>
				<span class="range-slider-fill" :style="{ width: valuePercent + '%' }"></span>
				<span class="range-slider-knob" ref="knob" :style="{ left: valuePercent + '%' }"> </span>
			</span>
		</drag-helper>
	</div>
</template>

<script>
import DragHelper from './DragHelper';
import { round } from './utils';
export default {
	props: {
		name: String,
		value: [String, Number],
		disabled: {
			type: Boolean,
			default: false
		},
		min: {
			type: [String, Number],
			default: 0
		},
		max: {
			type: [String, Number],
			default: 100
		},
		step: {
			type: [String, Number],
			default: 1
		},
		valueFormat: {
			type: Function,
			default: null
		}
	},
	data() {
		return {
			actualValue: null,
			dragStartValue: null,
			displayNumber: 0
		};
	},
	created() {
		this.displayNumber = this.value;
		const { _min: min, _max: max } = this;
		let defaultValue = Number(this.value);
		if (this.value == null || isNaN(defaultValue)) {
			if (min > max) {
				defaultValue = min;
			} else {
				defaultValue = (min + max) / 2;
			}
		}
		this.actualValue = this.round(defaultValue);
	},
	computed: {
		_min() {
			return Number(this.min);
		},
		_max() {
			return Number(this.max);
		},
		_step() {
			let step = Number(this.step);
			// if (this.actualValue >= 1000000) {
			// 	step = Number(this.step * 10);
			// }
			return Number(step);
		},
		valuePercent() {
			return ((this.actualValue - this._min) / (this._max - this._min)) * 100;
		},
		_valueFormat() {
			if (!this.valueFormat) {
				return new Intl.NumberFormat('ru-RU').format(this.actualValue);
			} else {
				return this.valueFormat(this.actualValue);
			}
		}
		// mountFormat
	},
	watch: {
		value(newValue) {
			const value = Number(newValue);
			if (newValue != null && !isNaN(value)) {
				this.actualValue = this.round(value);
			}

			// clearInterval(this.interval);
			// if(this.value == this.displayNumber){
			// 	return;
			// }
			// this.interval = window.setInterval(function(){
			// 	if(this.displayNumber != this.value){
			// 		var change = (this.value - this.displayNumber) / 10;
			// 		change = change >= 0 ? Math.ceil(change) : Math.floor(change);
			// 		this.displayNumber = this.displayNumber + change;
			// }
			// }.bind(this), 1);
		},
		min() {
			this.actualValue = this.round(this.actualValue);
		},
		max() {
			this.actualValue = this.round(this.actualValue);
		}
	},
	methods: {
		dragStart(event, offset) {
			this.dragStartValue = this.actualValue;
			if (event.target === this.$refs.knob) {
				return;
			}
			// If the click is out of knob, move it to mouse position
			this.drag(event, offset);
		},
		drag(event, offset) {
			const { offsetWidth } = this.$refs.inner;
			this.actualValue = this.round(this.valueFromBounds(offset.left, offsetWidth));
			this.emitInput(this.actualValue);
		},
		dragEnd(event, offset) {
			const { offsetWidth } = this.$refs.inner;
			this.actualValue = this.round(this.valueFromBounds(offset.left, offsetWidth));
			if (this.dragStartValue !== this.actualValue) {
				this.emitChange(this.actualValue);
			}
		},
		emitInput(value) {
			this.$emit('input', value);
		},
		emitChange(value) {
			this.$emit('change', value);
		},
		valueFromBounds(point, width) {
			return (point / width) * (this._max - this._min) + this._min;
		},
		round(value) {
			// if (this.value >= 1000000) {
			// 	return round(value, this._min - 30000, this._max, this._step);
			// } else {
			return round(value, this._min, this._max, this._step);
			// }
		}
	},
	components: {
		DragHelper
	}
};
</script>
